"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZDetailedAccountJournal = exports.ZAccountJournalSelectPrivate = exports.ZPlayerAccountSelectPrivate = exports.ZPaymentRefType = exports.ZPaymentMethod = exports.ZPaymentCurrency = void 0;
const dbEnums_1 = require("@daymade/common-lib/dbEnums");
const zod_1 = require("zod");
const zodSchemas_generated_1 = require("../generated/zodSchemas.generated");
exports.ZPaymentCurrency = zod_1.z.nativeEnum(dbEnums_1.PaymentCurrency);
exports.ZPaymentMethod = zod_1.z.nativeEnum(dbEnums_1.PaymentMethod);
exports.ZPaymentRefType = zod_1.z.nativeEnum(dbEnums_1.PaymentRefType);
exports.ZPlayerAccountSelectPrivate = zodSchemas_generated_1.zodSelectAccount.pick({
    playerId: true,
    currencyCode: true,
    mainBalance: true,
    giftCardBalance: true,
    promoBalance: true,
    tokenBalance: true,
});
exports.ZAccountJournalSelectPrivate = zodSchemas_generated_1.zodSelectAccountJournal
    .pick({
    id: true,
    playerId: true,
    totalFiatAmount: true,
    balanceAmount: true,
    giftCardAmount: true,
    promoAmount: true,
    paymentMethodAmount: true,
    tokenAmount: true,
    transactionType: true,
    comment: true,
    refType: true,
    refId: true,
    paymentMethod: true,
    paymentSessionId: true,
})
    .extend({
    createdAt: zod_1.z.coerce.date(),
});
exports.ZDetailedAccountJournal = exports.ZAccountJournalSelectPrivate.pick({
    id: true,
    refType: true,
    refId: true,
    transactionType: true,
    totalFiatAmount: true,
    balanceAmount: true,
    giftCardAmount: true,
    promoAmount: true,
    paymentMethodAmount: true,
    tokenAmount: true,
    comment: true,
    paymentMethod: true,
    paymentSessionId: true,
})
    .extend({
    createdAt: zod_1.z.coerce.date(),
    notes: zod_1.z.string(),
})
    .array();
//# sourceMappingURL=models.js.map